import React from 'react';
import { Container, CircularProgress } from '@mui/material';

const Loading = () => (
  <Container align="center">
    <CircularProgress />
  </Container>
);

export default Loading;
